"use client";

import { noop } from "es-toolkit";
import { Suspense } from "react";

import type { DataSource } from "~/data-sources/types/data-source";
import { Button } from "~/common/components/button";
import { IconCheckCircle } from "~/common/components/icons/check-circle";
import { DATA_SOURCE_ICONS } from "~/data-sources/components/data-source-icons";
import { dataSourceListStyle } from "~/data-sources/components/data-source-list/data-source-list.style";

type DataSourceListProps = {
  sources: DataSource[];
};

export function DataSourceList({ sources }: DataSourceListProps) {
  function redirectToAuthorize(uri: string) {
    window.location.replace(uri);
  }

  return (
    <div className={dataSourceListStyle.container()}>
      {sources?.map(({ name, isConnected, authorizeUri }) => {
        const Icon = DATA_SOURCE_ICONS[name];
        return (
          <Button
            key={name}
            className={dataSourceListStyle.source()}
            background="on-white"
            variant="ghost"
            onClick={() =>
              isConnected ? noop : redirectToAuthorize(authorizeUri)
            }
          >
            <span className={dataSourceListStyle.icon()}>
              <Suspense>
                <Icon
                  height={25}
                  width={25}
                />
              </Suspense>
            </span>
            <span className={dataSourceListStyle.title()}>
              Sign in with {name}
            </span>
            <span
              className={dataSourceListStyle.connection({
                variant: isConnected ? undefined : "inactive",
              })}
            >
              {isConnected ? "Connected" : "Not connected"}
              <IconCheckCircle
                color="#047846"
                className={dataSourceListStyle.checkIcon()}
              />
            </span>
          </Button>
        );
      })}
    </div>
  );
}
